export default "__VITE_ASSET__DtnM0vzc__"